export default __webpack_public_path__ + "static/media/gprf.bbc5dc91.jpeg";